import React, { useEffect, useState } from "react";
import BundleForm from "../../../forms/Bundles/index";
import { GetProducts } from "../../../services/product";
import useProductsStore from "../../../store/product";
import { GetSingleBundle } from "../../../services/bundle";
import { useParams } from "react-router-dom";
import { GetCategories } from "../../../services/category";
import { GetBoxes } from "../../../services/box";

const ViewSingleBundle = () => {
  const { id } = useParams();

  const { setProducts, products } = useProductsStore();
  const [categories, setCategories] = useState();
  const [boxes, setBoxes] = useState([]);
  const [bundle, setBundle] = useState(null);

  const handleSubmit = (bundle) => {
    // return CreateSingleBundle(bundle);
  };
  const fetchProducts = async () => {
    if (!products.length) {
      const { data } = await GetProducts();
      if (data?.result) {
        setProducts(data.result);
      }
    }
  };

  const fetchBundle = async () => {
    const { data } = await GetSingleBundle(id);
    if (data.result) {
      setBundle(data.result);
    }
  };

  const fetchCategories = async () => {
    const { data } = await GetCategories();
    if (data.result) {
      setCategories(data.result);
    }
  };

  const fetchBoxes = async () => {
    const { data } = await GetBoxes();
    if (data.result) {
      setBoxes(data.result);
    }
  };

  useEffect(() => {
    fetchBundle();
  }, [id]);
  useEffect(() => {
    fetchProducts();
    fetchBoxes();
    fetchCategories();
  }, []);
  return (
    <>
      {bundle ? (
        <BundleForm
          editable={false}
          onSubmit={handleSubmit}
          key={"create-bundle"}
          bundle={bundle}
          boxes={boxes}
          categories={categories}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default ViewSingleBundle;
